import type { RiskRatingBadgeProps } from '../types/components'
import { riskRatingBadgeStyle } from '../utils/riskRatingDisplay'
import styles from '../styles/applicationDetail.module.css'

export function RiskRatingBadge({ value, color, testId }: RiskRatingBadgeProps) {
  const style = riskRatingBadgeStyle(color)

  if (!style) {
    return <span data-testid={testId}>{value}</span>
  }

  return (
    <span
      className={styles.riskRatingBadge}
      data-testid={testId}
      style={style}
      title={value}
    >
      {value}
    </span>
  )
}
